<template>
  <div id="results-subview" class="py-1" style="min-height: calc(100vh - 50px)">
    <b-container v-if="loading">
      <b-row>
        <b-col class="loadingScreen">
          <div></div>
        </b-col>
      </b-row>
    </b-container>
    <b-container v-if="!loading && !currentEngagementReport.updatedAt">
      <b-row align-v="center" align-h="center" class="mt-0 mt-md-5">
        <b-col cols="12" sm="12" md="6" lg="5">
          <div class="panel text-center p-5">
            <h5>{{$t('journey:work-engagement-snapshot-teaser__body')}}</h5>
            <!-- <b-button class="mt-3" variant="outline-primary" to="/personal/survey">{{$t('personal-results:no-results-cta')}}</b-button> -->
          </div>
        </b-col>
      </b-row>
    </b-container>
    <b-container v-if="!loading && currentEngagementReport.updatedAt" fluid style="max-width: 1400px; margin: auto;" :class="{'overlayed': $route.name != 'TeamReports'}">
      <b-row no-gutters class="mt-3">
        <b-col cols="12" sm="12" md="6" lg="4" class="p-3">
          <div class="card insight-card" @click.stop="$router.push('/team/reports/engagement')">
            <div class="mb-2 py-2 pt-3 rounded-top" :style="{ background: mapColor(currentEngagementReport.categories['uwes9-total']) }">
              <span class="text-center" style="color: white;">
                <p><big style="font-size: 36px; line-height: 1">{{ $t(uwesToIndex(currentEngagementReport.stats['uwes9-total'].avg)) }}</big></p>
                <p style="line-height: 1">{{ $t('common:classification-'+currentEngagementReport.categories['uwes9-total'])}}</p>
              </span>
            </div>
            <!-- <img class="card-img-top" src="/img/illustrations/reports/theme_engagement.jpg"/> -->
            <div class="card-body" style="display: flex; flex-direction: column; align-items: stretch;">
              <h5 class="info-headline">{{$t('team-results:title-uwes')}}</h5>
              <div style="flex-grow: 1;">
                <h6><span>{{ $t('team-results:description-uwes') }}</span></h6>
              </div>
              <b-button style="flex-basis: 38px; flex-grow: 0; flex-shrink: 0;" variant="link" to="/team/reports/engagement">{{$t('common:view-details')}}</b-button>
            </div>
          </div>
        </b-col>

        <b-col cols="12" sm="12" md="6" lg="4" class="p-3">
          <div class="card insight-card" @click.stop="$router.push('/team/reports/vigor')">
            <div class="mb-2 py-2 pt-3 rounded-top" :style="{ background: mapColor(currentEngagementReport.categories['uwes9-vigor']) }">
              <span class="text-center" style="color: white;">
                <p><big style="font-size: 36px; line-height: 1">{{ $t(uwesToIndex(currentEngagementReport.stats['uwes9-vigor'])) }}</big></p>
                <p style="line-height: 1">{{ $t('common:classification-'+currentEngagementReport.categories['uwes9-vigor'])}}</p>
              </span>
            </div>
            <div class="card-body" style="display: flex; flex-direction: column; align-items: stretch;">
              <h5 class="info-headline">{{$t('common:title-vigor')}}</h5>
              <div style="flex-grow: 1;">
                <h6><span>{{$t('common:description-organization-vigor')}}</span></h6>
              </div>
              <b-button style="flex-basis: 38px; flex-grow: 0; flex-shrink: 0;" variant="link" to="/team/reports/vigor">{{$t('common:view-details')}}</b-button>
            </div>
          </div>
        </b-col>

        <!-- <b-col cols="12" sm="12" md="6" lg="4" class="p-3">
          <div class="card insight-card" @click.stop="$router.push('/team/reports/vigor')">
            <img class="card-img-top" src="/img/illustrations/reports/theme_vigor.jpg"/>
            <div class="card-body" style="display: flex; flex-direction: column; align-items: stretch;">
              <h5 class="info-headline">{{$t('common:title-vigor')}}</h5>
              <div style="flex-grow: 1;">
                <h6><span>{{$t('common:description-organization-vigor')}}</span></h6>
              </div>
              <b-button style="flex-basis: 38px; flex-grow: 0; flex-shrink: 0;" variant="link" to="/team/reports/vigor">{{$t('common:view-details')}}</b-button>
            </div>
          </div>
        </b-col> -->

        <b-col cols="12" sm="12" md="6" lg="4" class="p-3">
          <div class="card insight-card" @click.stop="$router.push('/team/reports/absorption')">
            <div class="mb-2 py-2 pt-3 rounded-top" :style="{ background: mapColor(currentEngagementReport.categories['uwes9-absorption']) }">
              <span class="text-center" style="color: white;">
                <p><big style="font-size: 36px; line-height: 1">{{ $t(uwesToIndex(currentEngagementReport.stats['uwes9-absorption'])) }}</big></p>
                <p style="line-height: 1">{{ $t('common:classification-'+currentEngagementReport.categories['uwes9-absorption'])}}</p>
              </span>
            </div>
            <div class="card-body" style="display: flex; flex-direction: column; align-items: stretch;">
              <h5 class="info-headline">{{$t('common:title-absorption')}}</h5>
              <div style="flex-grow: 1;">
                <h6><span>{{$t('common:description-organization-absorption')}}</span></h6>
              </div>
              <b-button style="flex-basis: 38px; flex-grow: 0; flex-shrink: 0;" variant="link" to="/team/reports/absorption">{{$t('common:view-details')}}</b-button>
            </div>
          </div>
        </b-col>

        <!-- <b-col cols="12" sm="12" md="6" lg="4" class="p-3">
          <div class="card insight-card" @click.stop="$router.push('/team/reports/absorption')">
            <img class="card-img-top" src="/img/illustrations/reports/theme_absorption.jpg"/>
            <div class="card-body" style="display: flex; flex-direction: column; align-items: stretch;">
              <h5 class="info-headline">{{$t('common:title-absorption')}}</h5>
              <div style="flex-grow: 1;">
                <h6><span>{{$t('common:description-organization-absorption')}}</span></h6>
              </div>
              <b-button style="flex-basis: 38px; flex-grow: 0; flex-shrink: 0;" variant="link" to="/team/reports/absorption">{{$t('common:view-details')}}</b-button>
            </div>
          </div>
        </b-col> -->

        <b-col cols="12" sm="12" md="6" lg="4" class="p-3">
          <div class="card insight-card" @click.stop="$router.push('/team/reports/dedication')">
            <div class="mb-2 py-2 pt-3 rounded-top" :style="{ background: mapColor(currentEngagementReport.categories['uwes9-dedication']) }">
              <span class="text-center" style="color: white;">
                <p><big style="font-size: 36px; line-height: 1">{{ $t(uwesToIndex(currentEngagementReport.stats['uwes9-dedication'])) }}</big></p>
                <p style="line-height: 1">{{ $t('common:classification-'+currentEngagementReport.categories['uwes9-dedication'])}}</p>
              </span>
            </div>
            <div class="card-body" style="display: flex; flex-direction: column; align-items: stretch;">
              <h5 class="info-headline">{{$t('common:title-dedication')}}</h5>
              <div style="flex-grow: 1;">
                <h6><span>{{$t('common:description-organization-dedication')}}</span></h6>
              </div>
              <b-button style="flex-basis: 38px; flex-grow: 0; flex-shrink: 0;" variant="link" to="/team/reports/dedication">{{$t('common:view-details')}}</b-button>
            </div>
          </div>
        </b-col>

        <!-- <b-col cols="12" sm="12" md="6" lg="4" class="p-3">
          <div class="card insight-card" @click.stop="$router.push('/team/reports/dedication')">
            <img class="card-img-top" src="/img/illustrations/reports/theme_dedication.jpg"/>
            <div class="card-body" style="display: flex; flex-direction: column; align-items: stretch;">
              <h5 class="info-headline">{{$t('common:title-dedication')}}</h5>
              <div style="flex-grow: 1;">
                <h6><span>{{$t('common:description-organization-dedication')}}</span></h6>
              </div>
              <b-button style="flex-basis: 38px; flex-grow: 0; flex-shrink: 0;" variant="link" to="/team/reports/dedication">{{$t('common:view-details')}}</b-button>
            </div>
          </div>
        </b-col> -->

        <b-col cols="12" sm="12" md="6" lg="4" class="p-3">
          <div class="card insight-card" @click.stop="$router.push('/team/reports/anxiety-gad-7')">
            <div class="mb-2 py-2 pt-3 rounded-top" style="background-color: #ccc;">
              <span class="text-center" style="color: white;">
                <p><big style="font-size: 36px; line-height: 69px;">
                  <icon name="eye-slash" size="lg" style="height: 1em; width: auto; max-width: 100%; max-height: 100%; font-size: 36px; opacity: 0;"/>
                </big></p>
              </span>
            </div>
            <!-- <img class="card-img-top" src="/img/illustrations/reports/theme_anxiety.jpg"/> -->
            <div class="card-body" style="display: flex; flex-direction: column; align-items: stretch;">
              <h5 class="info-headline">{{$t(`personal-results:title-anxiety-gad-7`)}}</h5>
              <div style="flex-grow: 1;">
                <h6><span>{{$t('personal-results:description-anxiety-gad-7')}}</span></h6>
              </div>
              <b-button style="flex-basis: 38px; flex-grow: 0; flex-shrink: 0;" variant="link" to="/team/reports/anxiety-gad-7">{{$t('common:view-details')}}</b-button>
            </div>
          </div>
        </b-col>

        <!-- <b-col cols="12" sm="12" md="6" lg="4" class="p-3" v-if="currentSatisfactionReport && currentSatisfactionReport.stats">
          <div class="card insight-card" @click.stop="$router.push('/team/reports/satisfaction')">
            <div class="mb-2 py-2 pt-3 rounded-top" :style="{ background: mapColor(currentEngagementReport.categories['uwes9-dedication']) }">
              <span class="text-center" style="color: white;">
                <p><big style="font-size: 36px; line-height: 1">{{ satisfactionToIndex(currentSatisfactionReport.stats.avg) }}</big></p>
              </span>
            </div>
            <div class="card-body" style="display: flex; flex-direction: column; align-items: stretch;">
              <h5 class="info-headline">Satisfaction</h5>
              <div style="flex-grow: 1;">
                <p>How happy are your members to work in the work community?</p>
                Positive — {{ formatPercent(currentSatisfactionReport.stats.classHappyPercentage + currentSatisfactionReport.stats.classSomewhatHappyPercentage) }}
                Neutral — {{ formatPercent(currentSatisfactionReport.stats.classNeutralPercentage) }}
                Negative — {{ formatPercent(currentSatisfactionReport.stats.classSomewhatUnhappyPercentage + currentSatisfactionReport.stats.classUnhappyPercentage) }}
                <ul>
                  <li>Happy: {{ currentSatisfactionReport.stats.classHappy }}</li>
                  <li>Somewhat happy: {{ currentSatisfactionReport.stats.classSomewhatHappy }}</li>
                  <li>Neutral: {{ currentSatisfactionReport.stats.classNeutral }}</li>
                  <li>Somewhat unhappy: {{ currentSatisfactionReport.stats.classSomewhatUnhappy }}</li>
                  <li>Unhappy: {{ currentSatisfactionReport.stats.classUnhappy }}</li>
                </ul>
              </div>
              <b-button style="flex-basis: 38px; flex-grow: 0; flex-shrink: 0;" variant="link" to="/team/reports/satisfaction">{{$t('common:view-details')}}</b-button>
            </div>
          </div>
        </b-col> -->

        <b-col cols="12" sm="12" md="6" lg="4" class="p-3" v-if="currentRecommendationReport && currentRecommendationReport.recommendation">
          <div class="card insight-card" @click.stop="$router.push('/team/reports/advocacy')">
            <div class="mb-2 py-2 pt-3 rounded-top" :style="{ background: mapAdvocacyColor(currentRecommendationReport.recommendation.average) }">
              <span class="text-center" style="color: white;">
                <p><big style="font-size: 36px; line-height: 1">{{ recommendationToIndex(currentRecommendationReport.recommendation.average) }}</big></p>
              </span>
            </div>
            <div class="card-body" style="display: flex; flex-direction: column; align-items: stretch;">
              <h5 class="info-headline">{{$t(`personal-results:title-advocacy`)}}</h5>
              <div style="flex-grow: 1;">
                {{$t(`personal-results:description-advocacy`)}}
              </div>
              <b-button style="flex-basis: 38px; flex-grow: 0; flex-shrink: 0;" variant="link" to="/team/reports/advocacy">{{$t('common:view-details')}}</b-button>
            </div>
          </div>
        </b-col>

        <!-- <b-col cols="12" sm="12" md="6" lg="4" class="p-3" v-if="currentRecommendationReport && currentRecommendationReport.recommendation">
          <div class="card insight-card">
            <img class="card-img-top" src="/img/illustrations/reports/theme_recommendation.jpg"/>
            <div class="card-body" style="display: flex; flex-direction: column; align-items: stretch;">
              <h5 class="info-headline">{{$t('common:title-recommendation')}}</h5>
              <div style="flex-grow: 1;">
                <h6><span>{{$t('personal-results:recommendation-categorical-title-'+currentRecommendationReport.recommendation[0].class)}}</span></h6>
              </div>
            </div>
          </div>
        </b-col> -->

      </b-row>
    </b-container>
    <div class="subnav text-center" v-if="$route.name != 'TeamReports'">
      <b-button style="vertical-align: top;" :disabled="availableReports.indexOf(openedReport) === 0" variant="link"  :to="availableReports[availableReports.indexOf(openedReport)-1]"><icon name="angle-left"/></b-button>
      <span class="subnav-progress">
        <router-link class="item" :key="index" v-for="(report, index) in availableReports" :class="{'active': report === openedReport}" :to="report"></router-link>
      </span>
      <b-button style="vertical-align: top;" :disabled="availableReports.indexOf(openedReport) >= availableReports.length -1" variant="link" :to="availableReports[availableReports.indexOf(openedReport)+1]"><icon name="angle-right"/></b-button>
      <b-button variant="link" to="/team/reports" style="position: absolute; right: 0;"><icon name="times"/></b-button>
    </div>
    <transition name="zoom" mode="in-out" enter-active-class="zoom-enter-active">
      <router-view v-touch:swipe="swipeHandler"/>
    </transition>
  </div>
</template>
<script>
// import { mapGetters } from 'vuex'
import numeral from 'numeral'
// import BarChart from '../common/barchart/BarChart'

export default {
  components: {
    // 'barchart': BarChart
  },
  data () {
    return {
      availableReports: ['engagement', 'vigor', 'absorption', 'dedication', 'anxiety-gad-7', 'advocacy'],
      openedReport: null,
      currentEngagementReport: null,
      engagementHistory: null,
      currentSatisfactionReport: null,
      currentRecommendationReport: null,
      historyRecommendationReport: null,
      loadingCurrentEngagementReport: true,
      loadingEngagementHistory: true
    }
  },
  created () {
    this.$router.beforeEach((to, from, next) => {
      if (to.meta.transitionName === 'zoom') {
        document.body.style.overflow = 'hidden'
      }
      if (from.meta.transitionName === 'zoom') {
        document.body.style.overflow = 'auto'
      }
      next()
    })
  },
  mounted () {
    this.loadCurrentEngagementReport()
    this.loadEngagementHistory()
    // this.loadSatisfactionReport()
    this.loadRecommendationReport()
  },
  methods: {
    uwesToIndex (uwes) { return this.formatNumber0(uwes / 6.0 * 100) },
    satisfactionToIndex (satisfactionAvg) { return this.formatNumber0((satisfactionAvg) / 3.0 * 100) },
    recommendationToIndex (recommendationAvg) { return this.formatNumber0((recommendationAvg) / 2.0 * 100) },
    loadCurrentEngagementReport () {
      this.loadingCurrentEngagementReport = true
      this.axios.get('/stats/current/engagement').then((response) => {
        this.currentEngagementReport = response.data
        this.loadingCurrentEngagementReport = false
      }).catch(err => {
        this.loadingCurrentEngagementReport = false
        throw err
      })
    },
    loadEngagementHistory () {
      this.loadingEngagementHistory = true
      this.axios.get('/stats/history/engagement').then((response) => {
        this.engagementHistory = response.data.reports
        this.loadingEngagementHistory = false
      }).catch(err => {
        this.loadingEngagementHistory = false
        throw err
      })
    },
    loadSatisfactionReport () {
      this.axios.get('/stats/current/satisfaction').then((response) => {
        this.currentSatisfactionReport = response.data
      }).catch(err => {
        this.satisfactionLoader = false
        throw err
      })
    },
    loadRecommendationReport () {
      // this.axios.get('/stats/current/recommendation').then((response) => {
      //   this.currentRecommendationReport = response.data
      // }).catch(err => {
      //   this.satisfactionLoader = false
      //   throw err
      // })
      this.axios.get('/stats/history/recommendation').then((response) => {
        this.historyRecommendationReport = response.data.reports
        const lastReportKey = Object.keys(this.historyRecommendationReport).sort().pop()
        if (lastReportKey) {
          this.currentRecommendationReport = this.historyRecommendationReport[lastReportKey]
          // this.$forceUpdate()
        }
      })
    },
    formatNumber (value) {
      return numeral(value).format('0.00')
    },
    formatNumber1 (value) {
      return numeral(value).format('0.0')
    },
    formatNumber0 (value) {
      return numeral(value).format('0')
    },
    formatPercent (value) {
      return numeral(value).format('0%')
    },
    mapColor: function (uwesClass) {
      const colors = {
        'very-high': '#377771',
        high: '#4ce0b3',
        average: '#ffce4c',
        low: '#ff8e72',
        'very-low': '#ed6a5e'
        // 'very-high': '#09AF5A',
        // high: '#2CC968',
        // average: '#009EC7',
        // low: '#DF485B',
        // 'very-low': '#C32F42'
      }
      return colors[uwesClass]
    },
    mapAdvocacyColor: function (average) {
      let classification = 'very-low'
      if (average < -0.4) {
        classification = 'very-low'
      } else if (average < 0.6) {
        classification = 'low'
      } else if (average < 1.0) {
        classification = 'average'
      } else if (average < 1.8) {
        classification = 'high'
      } else {
        classification = 'very-high'
      }
      return this.mapColor(classification)
    },
    swipeHandler (direction) {
      if (direction === 'right' && this.availableReports.indexOf(this.openedReport) !== 0) {
        this.$router.push(this.availableReports[this.availableReports.indexOf(this.openedReport) - 1])
      }
      if (direction === 'left' && this.availableReports.indexOf(this.openedReport) < this.availableReports.length - 1) {
        this.$router.push(this.availableReports[this.availableReports.indexOf(this.openedReport) + 1])
      }
    }
  },
  computed: {
    loading: function () {
      return this.loadingCurrentEngagementReport === true || this.loadingEngagementHistory === true
    },
    teamUWESPercent: function () {
      if (this.currentEngagementReport && this.currentEngagementReport.stats) {
        return this.formatPercent(this.currentEngagementReport.stats['uwes9-total'].avg / 6.0)
      }
      return this.formatPercent(0)
    },
    teamVigorPercent: function () {
      if (this.currentEngagementReport && this.currentEngagementReport.stats && this.currentEngagementReport.stats['uwes9-vigor']) {
        return this.formatPercent(this.currentEngagementReport.stats['uwes9-vigor'] / 6.0)
      }
      return this.formatPercent(0)
    },
    teamAbsorptionPercent: function () {
      if (this.currentEngagementReport && this.currentEngagementReport.stats && this.currentEngagementReport.stats['uwes9-absorption']) {
        return this.formatPercent(this.currentEngagementReport.stats['uwes9-absorption'] / 6.0)
      }
      return this.formatPercent(0)
    },
    teamDedicationPercent: function () {
      if (this.currentEngagementReport && this.currentEngagementReport.stats && this.currentEngagementReport.stats['uwes9-dedication']) {
        return this.formatPercent(this.currentEngagementReport.stats['uwes9-dedication'] / 6.0)
      }
      return this.formatPercent(0)
    },
    workEngagementItems: function () {
      return [
        {
          title: this.$t('common:classification-title-very-high'),
          color: '#377771',
          percentage: this.formatPercent(this.currentEngagementReport.stats['uwes9-total'].classVeryHigh / this.currentEngagementReport.stats['uwes9-total'].respondents)
        },
        {
          title: this.$t('common:classification-title-high'),
          color: '#4ce0b3',
          percentage: this.formatPercent(this.currentEngagementReport.stats['uwes9-total'].classHigh / this.currentEngagementReport.stats['uwes9-total'].respondents)
        },
        {
          title: this.$t('common:classification-title-average'),
          color: '#ffce4c',
          percentage: this.formatPercent(this.currentEngagementReport.stats['uwes9-total'].classAverage / this.currentEngagementReport.stats['uwes9-total'].respondents)
        },
        {
          title: this.$t('common:classification-title-low'),
          color: '#ff8e72',
          percentage: this.formatPercent(this.currentEngagementReport.stats['uwes9-total'].classLow / this.currentEngagementReport.stats['uwes9-total'].respondents)
        },
        {
          title: this.$t('common:classification-title-very-low'),
          color: '#ed6a5e',
          percentage: this.formatPercent(this.currentEngagementReport.stats['uwes9-total'].classVeryLow / this.currentEngagementReport.stats['uwes9-total'].respondents)
        }
      ]
    },
    vigorItems: function () {
      return [
        {
          title: this.$t('common:classification-title-very-high'),
          percentage: this.formatPercent(this.currentEngagementReport.vigor.classVeryHigh / this.currentEngagementReport.vigor.respondents),
          color: '#377771'
        },
        {
          title: this.$t('common:classification-title-high'),
          percentage: this.formatPercent(this.currentEngagementReport.vigor.classHigh / this.currentEngagementReport.vigor.respondents),
          color: '#4ce0b3'
        },
        {
          title: this.$t('common:classification-title-average'),
          percentage: this.formatPercent(this.currentEngagementReport.vigor.classAverage / this.currentEngagementReport.vigor.respondents),
          color: '#ffce4c'
        },
        {
          title: this.$t('common:classification-title-low'),
          percentage: this.formatPercent(this.currentEngagementReport.vigor.classLow / this.currentEngagementReport.vigor.respondents),
          color: '#ff8e72'
        },
        {
          title: this.$t('common:classification-title-very-low'),
          percentage: this.formatPercent(this.currentEngagementReport.vigor.classVeryLow / this.currentEngagementReport.vigor.respondents),
          color: '#ed6a5e'
        }
      ]
    },
    absorptionItems: function () {
      return [
        {
          title: this.$t('common:classification-title-very-high'),
          percentage: this.formatPercent(this.currentEngagementReport.absorption.classVeryHigh / this.currentEngagementReport.absorption.respondents),
          color: '#377771'
        },
        {
          title: this.$t('common:classification-title-high'),
          percentage: this.formatPercent(this.currentEngagementReport.absorption.classHigh / this.currentEngagementReport.absorption.respondents),
          color: '#4ce0b3'
        },
        {
          title: this.$t('common:classification-title-average'),
          percentage: this.formatPercent(this.currentEngagementReport.absorption.classAverage / this.currentEngagementReport.absorption.respondents),
          color: '#ffce4c'
        },
        {
          title: this.$t('common:classification-title-low'),
          percentage: this.formatPercent(this.currentEngagementReport.absorption.classLow / this.currentEngagementReport.absorption.respondents),
          color: '#ff8e72'
        },
        {
          title: this.$t('common:classification-title-very-low'),
          percentage: this.formatPercent(this.currentEngagementReport.absorption.classVeryLow / this.currentEngagementReport.absorption.respondents),
          color: '#ed6a5e'
        }
      ]
    },
    dedicationItems: function () {
      return [
        {
          title: this.$t('common:classification-title-very-high'),
          percentage: this.formatPercent(this.currentEngagementReport.dedication.classVeryHigh / this.currentEngagementReport.dedication.respondents),
          color: '#377771'
        },
        {
          title: this.$t('common:classification-title-high'),
          percentage: this.formatPercent(this.currentEngagementReport.dedication.classHigh / this.currentEngagementReport.dedication.respondents),
          color: '#4ce0b3'
        },
        {
          title: this.$t('common:classification-title-average'),
          percentage: this.formatPercent(this.currentEngagementReport.dedication.classAverage / this.currentEngagementReport.dedication.respondents),
          color: '#ffce4c'
        },
        {
          title: this.$t('common:classification-title-low'),
          percentage: this.formatPercent(this.currentEngagementReport.dedication.classLow / this.currentEngagementReport.dedication.respondents),
          color: '#ff8e72'
        },
        {
          title: this.$t('common:classification-title-very-low'),
          percentage: this.formatPercent(this.currentEngagementReport.dedication.classVeryLow / this.currentEngagementReport.dedication.respondents),
          color: '#ed6a5e'
        }
      ]
    },
    satisfactionItems: function () {
      return [
        {
          title: this.$t('common:classification-title-happy'),
          percentage: this.formatPercent(this.currentSatisfactionReport.stats.classHappyPercentage),
          color: '#377771'
        },
        {
          title: this.$t('common:classification-title-somewhat-happy'),
          percentage: this.formatPercent(this.currentSatisfactionReport.stats.classSomewhatHappyPercentage),
          color: '#4ce0b3'
        },
        {
          title: this.$t('common:classification-title-neutral'),
          percentage: this.formatPercent(this.currentSatisfactionReport.stats.classNeutralPercentage),
          color: '#ffce4c'
        },
        {
          title: this.$t('common:classification-title-somewhat-unhappy'),
          percentage: this.formatPercent(this.currentSatisfactionReport.stats.classSomewhatUnhappyPercentage),
          color: '#ff8e72'
        },
        {
          title: this.$t('common:classification-title-unhappy'),
          percentage: this.formatPercent(this.currentSatisfactionReport.stats.classUnhappyPercentage),
          color: '#ed6a5e'
        }
      ]
    }
  }
}
</script>
<style lang="scss">
</style>
